import Link from "next/link";
import React from "react";
import Tracker from "../../libs/Tracker";
import { ImageType } from "../../pages";

interface IProp {
  category: string;
  title: string;
  url: string;
  image: ImageType;
}

const SliderItem = (props: IProp) => {
  return (
    <Link href={props.url} passHref>
      <div
        className="h-full w-full rounded overflow-hidden cursor-pointer relative"
        onClick={() => {
          Tracker.amplitudeEvent("index_intro/click/menu", {
            category: props.category,
            menu: props.title,
          });
        }}
      >
        <img
          {...props.image}
          alt={props.image.alt}
          className="rounded"
          loading="lazy"
        />
        <div className="text-left top-0 m-2 px-2 py-1 text-sm font-bold rounded text-white absolute bg-text-primary/30 backdrop-blur-sm">
          {props.title.replace("DeepSearch ", "") ?? "ABC"}
        </div>
      </div>
    </Link>
  );
};

export default SliderItem;
